@if (active) {
  <ng-content></ng-content>
}
